<template>
    <div class="btns-content">
        <img v-if="showShareBtn" alt="" src="../../../assets/images/postalNewCustomer/button_share.png" @click="inviteShare">
        <img v-if="showRuleBtn" @click="onclickRule" alt="" src="../../../assets/images/postalNewCustomer/button_rule.png">
        <router-link v-if="showRewardBtn" :to="{ name: 'reward' }">
            <img alt="" src="../../../assets/images/postalNewCustomer/button_my_reward.png">
        </router-link>
    </div>
</template>

<script>
export default {
    name: "ButtonContent",
    props: {
        showRuleBtn: {
            type: Boolean,
            default: true
        },
        showRewardBtn: {
            type: Boolean,
            default: true
        },
        ruleName: {
            type: String,
            default: 'rule'
        },
        showShareBtn: {
            type: Boolean,
            default: true
        },
        showType: {
            type: String,
            default: ''
        }
    },
    methods: {
        //规则跳转
        onclickRule() {
            this.$router.push({ name: this.ruleName, query: { type: this.showType } })
        },
        inviteShare() {
            window.shareSuccess = () => {
            };
            const url = process.env.VUE_APP_URL + 'postalShareIndex?source=5';
            if (this.$store.state.app.system === "ios") {
                let message = {
                    url,         //分享出去的URL
                    title: '绿色出行 “邮”享好礼',        //分享出去的标题
                    content: '青碳行&中国邮储银行青岛市分行举办，最高可得88.88元数字人民币。',      //分享出去的描述
                    isImageOnly: "0",  //是否为图片分享,"1"表示true ‘0’表示false
                    imageUrl: 'https://carbon.lcago.cn/file/202210/11/d303f489421650a935235d0328120ec1e4255e1e5ded4569c1ace5d5be008fa8.png', //普通分享中必须使用该字段；分享图片的URL
                    imageBase64: '',  //分享图片的base64,imageUrl优先级高于base64
                    saveable: "0",     //是否支持保存本地，保存本地的图片使用imageUrl或者imageBase64字段，"1"表示true ‘0’表示false
                    copyable: "1",     //是否支持复制链接，"1"表示true ‘0’表示false
                    copyLink: "",     //复制链接的URL,如果不存在，默认使用url
                    posterUrl: '',
                    copyUrl: '0'
                }
                window.webkit.messageHandlers.QTX_H5_SHARE.postMessage(message)

            } else if (this.$store.state.app.system === "android") {
                let jsonParam = {
                    type: 1, //分享类型：1链接 2图片Url 3图片Base64
                    needSavePic: false, //是否显示保存本地
                    needCopyLink: true, //是否显示拷贝链接
                    title: '绿色出行 “邮”享好礼', //标题
                    desc: '青碳行&中国邮储银行青岛市分行举办，最高可得88.88元数字人民币。', //描述
                    url, //链接
                    thumb: 'https://carbon.lcago.cn/file/202210/11/d303f489421650a935235d0328120ec1e4255e1e5ded4569c1ace5d5be008fa8.png', //分享链接时的缩略图
                    base64Pic: '', //图片Base64
                }

                window.CarbonWebView.appShare(JSON.stringify(jsonParam), 'shareSuccess');
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "./function";

.btns-content {
    position: fixed;
    right: 2px;
    top: 20vh;
    padding: pxvw(25) pxvw(10) px2rem(32);
    border-radius: pxvw(45) 0 0 pxvw(45);
    border: pxvw(2) solid #e3bec8;
    margin-right: pxvw(-10);
    z-index: 1000;
    background: rgba(255, 255, 255, 0.7);

    img {
        margin-top: pxvw(4);
        width: pxvw(86);
        height: auto;
        display: block;
    }
}
</style>
